<template>
  <div class="home dark-mode">
    <div class="hero-section">
      <img alt="Moja Garderoba logo" src="../assets/logo.png" class="logo" />
      <h1 class="main-title">Moja Garderoba</h1>
      <p class="tagline">Vaš ormar zaslužuje novi život!</p>

      <div class="cta-container">
        <router-link
          v-if="!isLoggedIn"
          to="/register"
          class="cta-button primary"
          >Pridruži se sada</router-link
        >
        <router-link v-else to="/products" class="cta-button primary"
          >Pregledaj garderobu</router-link
        >
        <router-link to="/products" class="cta-button secondary"
          >Istraži garderobu</router-link
        >
      </div>

      <!-- Dodajemo sekciju za Android aplikaciju -->
      <div class="app-download-section">
        <p class="app-promo-text">
          Ili skinite našu Android aplikaciju za još lakše korišćenje!
        </p>
        <a
          href="market://details?id=rs.mojagarderoba"
          onclick="setTimeout(() => { window.location='https://play.google.com/store/apps/details?id=rs.mojagarderoba&hl=sr'; }, 500);"
          rel="noopener noreferrer"
          class="app-download-button"
        >
          <i class="fab fa-google-play"></i>
          <span>Preuzmite na Google Play</span>
        </a>
      </div>
    </div>

    <div class="benefits-section">
      <h2>Zašto Moja Garderoba?</h2>

      <div class="benefits-grid">
        <div class="benefit-card">
          <div class="icon-container">
            <i class="fas fa-tshirt"></i>
          </div>
          <h3>Oslobodi svoj ormar</h3>
          <p>
            Prodaj garderobu koju ne nosiš i zaradi novac umesto da zauzima
            prostor.
          </p>
        </div>

        <div class="benefit-card">
          <div class="icon-container">
            <i class="fas fa-leaf"></i>
          </div>
          <h3>Čuvaj planetu</h3>
          <p>
            Svaki komad garderobe koji prodaš je korak ka održivoj modi i
            čistijoj planeti.
          </p>
        </div>

        <div class="benefit-card">
          <div class="icon-container">
            <i class="fas fa-coins"></i>
          </div>
          <h3>Uštedi novac</h3>
          <p>
            Pronađi kvalitetne komade po pristupačnim cenama - stil ne mora biti
            skup.
          </p>
        </div>

        <div class="benefit-card">
          <div class="icon-container">
            <i class="fas fa-users"></i>
          </div>
          <h3>Poveži se</h3>
          <p>
            Postani deo zajednice ljubitelja mode koji dele tvoj ukus i
            vrednosti.
          </p>
        </div>
      </div>
    </div>

    <div class="how-it-works">
      <h2>Kako funkcioniše?</h2>

      <div class="steps-container">
        <div class="step">
          <div class="step-number">1</div>
          <h3>Napravi nalog</h3>
          <p>
            Registruj se u par koraka i kreiraj svoj profil na Mojoj Garderobi.
          </p>
        </div>

        <div class="step">
          <div class="step-number">2</div>
          <h3>Fotografiši i postavi</h3>
          <p>
            Uslikaj garderobu koju želiš da prodaš i postavi je na par klikova.
          </p>
        </div>

        <div class="step">
          <div class="step-number">3</div>
          <h3>Prodaj ili kupuj</h3>
          <p>
            Pronađi nove vlasnike za svoju garderobu ili otkrij nove komade za
            svoj stil.
          </p>
        </div>
      </div>

      <router-link
        v-if="!isLoggedIn"
        to="/register"
        class="cta-button primary large"
        >Započni odmah!</router-link
      >
      <router-link v-else to="/products" class="cta-button primary large"
        >Pregledaj ponudu</router-link
      >
    </div>

    <div class="testimonials">
      <h2>Šta korisnici kažu</h2>

      <div class="testimonial-carousel">
        <div class="testimonial">
          <p>
            "Od kada sam otkrila Moju Garderobu, moj ormar je organizovaniji, a
            džep puniji. Obožavam što mogu da prodajem stvari koje više ne
            nosim!"
          </p>
          <p class="testimonial-author">- Marina J.</p>
        </div>

        <div class="testimonial">
          <p>
            "Našao sam neke od svojih omiljenih komada garderobe ovde. Kvalitet
            je odličan, a cene su neverovatne!"
          </p>
          <p class="testimonial-author">- Stefan M.</p>
        </div>

        <div class="testimonial">
          <p>
            "Moja Garderoba nije samo sajt za kupovinu i prodaju - to je
            zajednica istomišljenika koji brinu o održivoj modi."
          </p>
          <p class="testimonial-author">- Ana D.</p>
        </div>
      </div>
    </div>

    <!-- Stats sekcija je uklonjena po zahtevu -->

    <div class="final-cta">
      <h2>Spreman/na da daš novu priliku svojoj garderobi?</h2>
      <p>
        Pridruži se hilјadama korisnika koji već uživaju u prednostima Moje
        Garderobe!
      </p>
      <router-link
        v-if="!isLoggedIn"
        to="/register"
        class="cta-button primary extra-large"
        >Registruj se besplatno</router-link
      >
      <router-link v-else to="/products" class="cta-button primary extra-large"
        >Pregledaj ponudu</router-link
      >
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

export default defineComponent({
  name: 'HomeView',
  computed: {
    // Koristi direktno store.state umesto gettera
    ...mapState({
      // Proverava direktno da li postoji token u localStorage
      isLoggedIn: () => !!localStorage.getItem('token'),
    }),
  },
  mounted() {
    // Dodajemo Font Awesome za ikone ako već nije učitan
    if (!document.getElementById('font-awesome-css')) {
      const link = document.createElement('link');
      link.id = 'font-awesome-css';
      link.rel = 'stylesheet';
      link.href =
        'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css';
      document.head.appendChild(link);
    }

    // Dodajemo Google Fonts za Poppins font koji koristimo
    if (!document.getElementById('google-fonts')) {
      const link = document.createElement('link');
      link.id = 'google-fonts';
      link.rel = 'stylesheet';
      link.href =
        'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;800&display=swap';
      document.head.appendChild(link);
    }
  },
});
</script>

<style scoped>
html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen, Ubuntu, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #0d1321;
}

.dark-mode {
  background-color: #0d1321; /* Tamno plava pozadina umesto crne */
  color: #f5f5f5;
  min-height: 100vh;
}

.home {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 80px 0;
}

.logo {
  width: 120px;
  margin-bottom: 20px;
}

.main-title {
  font-size: 3.5rem;
  margin-bottom: 16px;
  background: linear-gradient(45deg, #6a11cb, #2575fc);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: 800;
  font-family: 'Poppins', sans-serif; /* Dodajemo font za bolji izgled */
}

.tagline {
  font-size: 1.5rem;
  margin-bottom: 40px;
  font-weight: 300;
  color: #e0e0e0;
}

.cta-container {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.cta-button,
a.cta-button {
  padding: 12px 28px;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

.cta-button.primary {
  background: linear-gradient(45deg, #6a11cb, #2575fc);
  color: white;
  box-shadow: 0 4px 15px rgba(106, 17, 203, 0.3);
}

.cta-button.primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(106, 17, 203, 0.4);
}

.cta-button.secondary {
  background: transparent;
  border: 2px solid #6a11cb;
  color: #f5f5f5;
}

.cta-button.secondary:hover {
  background: rgba(106, 17, 203, 0.1);
  transform: translateY(-3px);
}

.cta-button.large {
  padding: 14px 34px;
  font-size: 1.1rem;
}

.cta-button.extra-large {
  padding: 16px 40px;
  font-size: 1.2rem;
}

/* Stilovi za sekciju preuzimanja aplikacije */
.app-download-section {
  margin-top: 50px;
  padding: 20px;
  text-align: center;
}

.app-promo-text {
  font-size: 1.1rem;
  color: #e0e0e0;
  margin-bottom: 20px;
  font-weight: 300;
}

.app-download-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(45deg, #34a853, #4285f4);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(52, 168, 83, 0.3);
}

.app-download-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(52, 168, 83, 0.4);
}

.app-download-button i {
  font-size: 1.2rem;
}

.benefits-section,
.how-it-works,
.testimonials,
.final-cta {
  margin: 100px 0;
  text-align: center;
}

h2 {
  font-size: 2.2rem;
  margin-bottom: 50px;
  color: #f5f5f5;
  position: relative;
  display: inline-block;
}

h2::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: linear-gradient(45deg, #6a11cb, #2575fc);
  border-radius: 2px;
  box-shadow: 0 0 8px rgba(106, 17, 203, 0.4); /* Dodajemo efekat sjaja */
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin: 0 auto;
}

.benefit-card {
  background-color: transparent;
  border-radius: 16px;
  padding: 30px;
  transition: transform 0.3s ease;
  height: 100%;
  border: 1px solid #1e2e4a; /* Tamnoplavi okvir umesto sivocrnog */
}

.benefit-card:hover {
  transform: translateY(-10px);
}

.icon-container {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #6a11cb;
}

.steps-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: 50px;
  gap: 20px;
  align-items: stretch;
}

.step {
  width: 280px;
  margin: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px;
  box-sizing: border-box;
  min-height: 200px;
}

.step-number {
  width: 50px;
  height: 50px;
  background: linear-gradient(45deg, #6a11cb, #2575fc);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
  margin: 0 auto 20px;
  text-align: center;
  line-height: 1;
  flex-shrink: 0;
}

.step h3 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 1.3rem;
  word-wrap: break-word;
}

.step p {
  margin: 0;
  line-height: 1.6;
  word-wrap: break-word;
  hyphens: auto;
  max-width: 100%;
}

.testimonial-carousel {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  gap: 30px;
  padding: 20px 0;
  margin-bottom: 50px;
  -webkit-overflow-scrolling: touch; /* Za bolje skrolovanje na iOS uređajima */
  scrollbar-width: thin; /* Za Firefox */
}

.testimonial-carousel::-webkit-scrollbar {
  height: 6px;
}

.testimonial-carousel::-webkit-scrollbar-track {
  background: rgba(30, 46, 74, 0.5);
  border-radius: 10px;
}

.testimonial-carousel::-webkit-scrollbar-thumb {
  background: linear-gradient(45deg, #6a11cb, #2575fc);
  border-radius: 10px;
}

.testimonial {
  background-color: transparent;
  border-left: 4px solid #6a11cb;
  padding: 30px;
  border-radius: 8px;
  min-width: 280px;
  max-width: 85vw; /* Ograničavamo širinu za mobilne uređaje */
  scroll-snap-align: start;
  border: 1px solid #1e2e4a;
  flex-shrink: 0; /* Sprečava smanjivanje elemenata u flex kontejneru */
}

.testimonial p {
  font-style: italic;
  margin-bottom: 20px;
}

.testimonial-author {
  font-weight: bold;
  color: #e0e0e0;
}

.stats-section {
  /* Uklanjamo stilove za ovu sekciju jer je uklonjena */
  display: none;
}

.stat h3 {
  font-size: 2.5rem;
  margin-bottom: 10px;
  background: linear-gradient(45deg, #6a11cb, #2575fc);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.final-cta {
  background-color: transparent;
  padding: 60px 30px;
  border-radius: 16px;
  margin-bottom: 80px;
  border: 1px solid #1e2e4a; /* Tamnoplavi okvir umesto sivocrnog */
}

.final-cta p {
  margin-bottom: 30px;
  font-size: 1.2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 768px) {
  .cta-container {
    flex-direction: column;
    width: 100%;
    gap: 15px;
  }

  .cta-button,
  a.cta-button {
    width: 100%;
    text-align: center;
  }

  .main-title {
    font-size: 2.5rem;
  }

  .tagline {
    font-size: 1.2rem;
  }

  /* Stilovi za mobilne uređaje - sekcija preuzimanja aplikacije */
  .app-download-section {
    margin-top: 40px;
    padding: 15px;
  }

  .app-promo-text {
    font-size: 1rem;
    margin-bottom: 15px;
  }

  .app-download-button {
    padding: 10px 20px;
    font-size: 0.9rem;
  }

  h2 {
    font-size: 1.8rem;
  }

  .benefits-grid {
    grid-template-columns: 1fr;
  }

  .steps-container {
    flex-direction: column;
    align-items: center;
    gap: 30px;
    padding: 0 20px;
  }

  .step {
    width: 100%;
    max-width: 320px;
    margin: 0;
    padding: 25px 20px;
    background: rgba(30, 46, 74, 0.1);
    border-radius: 12px;
    border: 1px solid #1e2e4a;
    min-height: auto;
  }

  .step-number {
    width: 45px;
    height: 45px;
    font-size: 1.3rem;
    margin-bottom: 15px;
  }

  .step h3 {
    font-size: 1.2rem;
    margin-bottom: 12px;
  }

  .step p {
    font-size: 0.95rem;
    line-height: 1.5;
  }

  .hero-section {
    padding: 40px 0;
  }

  .benefits-section,
  .how-it-works,
  .testimonials,
  .final-cta {
    margin: 60px 0;
  }
}

@media (max-width: 480px) {
  .main-title {
    font-size: 2rem;
  }

  .hero-section {
    padding: 30px 0;
  }

  .benefit-card,
  .testimonial {
    padding: 20px;
  }

  .final-cta {
    padding: 40px 20px;
  }

  /* Dodatni stilovi za vrlo male ekrane */
  .app-download-section {
    margin-top: 35px;
    padding: 10px;
  }

  .app-promo-text {
    font-size: 0.95rem;
  }

  .app-download-button {
    padding: 10px 16px;
    font-size: 0.85rem;
    gap: 8px;
  }

  h2 {
    font-size: 1.5rem;
  }

  .home {
    padding: 0 15px;
  }

  .steps-container {
    padding: 0 15px;
  }

  .step {
    max-width: 100%;
    padding: 20px 15px;
  }

  .step-number {
    width: 40px;
    height: 40px;
    font-size: 1.2rem;
    margin-bottom: 12px;
  }

  .step h3 {
    font-size: 1.1rem;
    margin-bottom: 10px;
  }

  .step p {
    font-size: 0.9rem;
    line-height: 1.4;
  }

  .steps-container {
    gap: 20px;
  }
}
</style>
